import dayjs from 'dayjs';
import { cloneElement } from 'react';

import type { DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import type { Dayjs } from 'dayjs';
import type { FC } from 'react';
import type { ControllerProps } from 'react-hook-form';

interface MuiDatePickerAdapterProps
  extends Partial<Omit<Parameters<ControllerProps['render']>[0], 'children'>>
{
  children: React.ReactElement<DatePickerProps<string>>;
  isExposingTextField?: boolean;
  template?: Parameters<Dayjs['format']>[0];
  // valueConverter?: (value: unknown) => string | null;
}

export const MuiDatePickerAdapter: FC<MuiDatePickerAdapterProps> = ({
  children,
  field,
  fieldState,
  formState,
  isExposingTextField = true,
  template,
  ...props
}) => {
  if (!field) return null;

  return cloneElement( children, {
    // @ts-expect-error
    value: field.value
      /* if field value exists, it will be an iso date string. Parse string back to dayjs object */
      ? dayjs( field.value )
      : null,
    onChange: (data) => {
      /* parse dayjs object to iso date string, so zod can validate it. */
      field.onChange( dayjs( data ).format( template ) );
    },
    slotProps: {
      textField: {
        /* display zod validation error message */
        /* if no error message, display whitespace to force the rendering of the paragraph. Preventive action to preventing content shifting */
        helperText: fieldState?.error?.message ?? ' ',
        error: !!fieldState?.error ?? undefined,
      },
    },
    ...props,
  } );
};
